module.exports = __webpack_public_path__ + "img/fm.c2377fd4.jpg";